<div class="nrc-zip-form">
  <div class="nrc-zip-form__input-wrap">
    <img class="nrc-zip-form__pin" src="assets/images/marker.svg" alt="" aria-hidden="true" />
    <input
      #zipInput
      name="zipcode"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      [placeholder]="placeholder"
      maxlength="5"
      [(ngModel)]="zipVal"
      (input)="onInput($event)"
      (focus)="onInputFocus()"
      (click)="onInputClick()"
      (keydown.enter)="onEnter($event)"
    />
    <button type="button" class="nrc-zip-form__btn" (click)="submit()" aria-label="Start My Estimate">
      <img class="nrc-zip-form__btn-icon" src="assets/images/search.svg" alt="" aria-hidden="true" />
      <span class="nrc-zip-form__btn-label nrc-zip-form__btn-label--desktop">Start My Estimate</span>
      <span class="nrc-zip-form__btn-label nrc-zip-form__btn-label--mobile">Get Estimate</span>
    </button>
  </div>
</div>
